
import React from 'react'
import { useAuth } from '../../context/AuthContext';

import { MoSpan, MoContainer, MoLink} from '../../Mo7/mo7UI'
import { cols, icons } from '../../services/design.sevice';

export default function AboutUs() {
    const { currentUser } = useAuth()

    return (
        <MoContainer pos="relative" flow_y='scroll' flow_x="hidden" h="100vh" scroller>
            {/* Navbar  */}
            <MoContainer sdw={{ x: "-5px", y: 0, sprd: ".5rem", op: "rgba(0,0,0,0.35)" }} flex h="5.5rem" w="100vw" bg="transparent" pos="absolute" z="1" >
                {/* Logo */}
                <MoContainer flex pd={{ l: "4rem" }} align="center">
                    <img height="45px" src={icons.logo2} alt="" />
                </MoContainer>
                {/* Links */}
                <MoContainer gap="2rem" pd={{ r: "4rem", l: "2rem" }} m_l="auto" align="center" flex >
                    <MoLink to="/home">Home</MoLink>
                    <MoLink col={cols.green} to="/dashboard/home"> {currentUser ? "My Dashboard" : "Sign In"}</MoLink>
                    <MoLink eff_hover="true" b_r={{ all: "5px" }} pd={{ tb: "10px", lr: '15px' }} bg={cols.green} col={cols.mainLight_1} to="/signup">Sign Up</MoLink>

                </MoContainer>
            </MoContainer>

            <MoContainer m_t="7rem" flex_c align="center">
                <MoSpan > About Us </MoSpan>
                <MoContainer w="60%" >
                    <MoSpan fs_mid col={cols.mainDark_1}> 🥳 Welcome to Tutor Bolt ⚡ ! Our objective is to offer you the most comprehensive selection of online and private tutors in your area 🥰. </MoSpan>
                </MoContainer>

            </MoContainer>


        </MoContainer>
    )
}
